<template>
    <div class="profile-thumbnail">
        <template v-if="!info['adbanner']">
            <div class="default-layout" v-if="layoutType == 'default'">
                <base-image class="pic-con image" @click.native="goToProfile" :image="info.thumb_picture" :blur-image="withBlur" alt="avatar">
                    <div class="icon-actions-wrapper">
                        <template v-if="info.premium && subscriptionAllowed">
                            <i v-if="showDesktop" class="icon icon-empty" @click.stop="goToPremium"><i class="icon icon-ribbon-white"></i></i>
                            <i v-else class="icon icon-ribbon-round" @click.stop="goToPremium"></i>
                        </template>
                        <i :class="`favorite fa fa-heart${is_favorite ? '' : '-o'}`" @click.stop="toggleFavorite" v-if="info.show_favorite_button"></i>
                        <i class="icon icon-envelope-solid message" @click.stop="goToChat"></i>
                    </div>
                </base-image>
                <div v-if="showDesktop" class="profile-details">
                    <h3 class="nick-name">{{ info.nick_name }}</h3>
                    <p class="age">{{ info.age }} {{ 'yrs' | translate }}</p>
                    <p class="province">{{ info.province_name }}</p>
                </div>
                <div v-if="!showDesktop" class="profile-details">
                    <h3 class="nick-name">{{ info.nick_name }}</h3>
                    <p class="member-meta">{{ info.age }} {{ 'yrs' | translate }}, {{ info.province_name }}</p>
                </div>
            </div>
            <div class="favorite-layout" v-if="layoutType == 'favorite'">
                <i v-if="hasCloseBtn" class="fa fa-times close-btn" @click="removeFavorite"></i>
                <base-image class="pic-con" @click.native="goToProfile" :image="info.thumb_picture" :blur-image="withBlur" alt="avatar"></base-image>
                <div class="profile-details">
                    <h3 class="nick-name">{{ info.nick_name }}</h3>
                    <p class="age">{{ info.age }} {{ 'yrs' | translate }}</p>
                    <p class="province">{{ info.province_name }}</p>
                    <div class="btn-con">
                        <button class="btn btn-primary" @click="goToProfile">
                            <span>{{ 'Visit Profile' | translate }}</span>
                        </button>
                        <button class="btn btn-chat" @click="goToChat">
                            <i class="icon icon-envelope"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="search-layout" v-if="layoutType == 'search'">
                <div class="profile-pic-wrapper">
                    <base-image class="pic-con" @click.native="goToProfile" :image="info.thumb_picture" :blur-image="withBlur" alt="avatar"></base-image>
                    <div class="icon-actions-wrapper">
                        <i v-if="info.premium && subscriptionAllowed" class="icon icon-ribbon-colored" @click.stop="goToPremium"></i>
                        <i class="icon icon-eye" @click.stop="goToProfile"></i>
                        <i class="icon icon-envelope" @click.stop="goToChat"></i>
                        <i :class="`fa fa-heart${is_favorite ? '' : '-o'}`" @click.stop="toggleFavorite" v-if="info.show_favorite_button"></i>
                    </div>
                </div>
                <div class="profile-details">
                    <h3 class="nick-name">{{ info.nick_name }}</h3>
                    <p class="age">{{ info.age }} {{ 'yrs' | translate }}</p>
                    <p class="province">{{ info.province_name }}</p>
                    <div class="user-info-list">
                        <p class="marital-status">{{ info.marital_status }}</p>
                        <p class="bmi">{{ info.height }} - {{ info.weight }}</p>
                        <p class="hari-color">{{ 'Hair Color' | translate }} - {{ info.hair_color }}</p>
                        <p class="hari-color">{{ 'Eye Color' | translate }} - {{ info.eye_color }}</p>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <adv-bannr v-if="info['type'] == 'multiple'" :banners="multiBannners" layout-type="multiple"></adv-bannr>
            <adv-bannr v-else layout-type="profile" @click.native="goToPremium"></adv-bannr>
        </template>
    </div>
</template>

<script>
    import BaseImage from '@views/common/BaseImage'
    import AdvBannr from '@views/user/partials/AdvBannr'
    import ProfileThumbnail from '@views/user/partials/ProfileThumbnail/profile_thumbnail'

    export default {
        mixins: [ProfileThumbnail],
        components: {
            BaseImage,
            AdvBannr
        }
    }
</script>

<style lang="scss" src="./profile_thumbnail.scss"></style>
